export const isHtmlFragmentHref = (href: string): boolean =>
  href.startsWith('#');
